import type { CSSObject, Theme } from '@mui/material'

/**
 * Apply within `&:focus-visible` or `&.Mui-focusVisible`, on the focusable element.
 * The outline follows its radius without changing layout or replacing its shadows.
 * Use inset for clipped surfaces or grouped controls whose neighbours cover an outer ring.
 */
export const focusRing = (theme: Theme, { inset = false }: { inset?: boolean } = {}): CSSObject => ({
  outline: `${theme.strokeWidth.focus} solid ${theme.palette.border.focus}`,
  outlineOffset: inset ? `-${theme.strokeWidth.focus}` : theme.strokeWidth.focus,
})
